

const Header = () => {


    return(
        <div className="Header-div">
            <header>Frontend Project using React JS</header>
            <h1>Finding Falcone!</h1>
        </div>
    )
}


export default Header;